import React, { useState, useEffect, useCallback } from 'react';
import { Alert } from '@mui/material';
import { GetReferralSummaryAPI } from '../../api/ReferralAPI';
import Toast from '../../components/support/Toast';
import ReferralLinkCard from './components/ReferralLinkCard';
import ReferralIndicateCard from './components/ReferralIndicateCard';
import ReferralListCard from './components/ReferralListCard';
import styles from './Referral.module.css';

const EMPTY_COUNTS = { invited: 0, signed_up: 0, subscribed: 0, rewarded: 0 };

// Tela "Indique e ganhe": link pessoal, indicação direta e a lista de indicações
const Referral = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });

  const load = useCallback(() => {
    GetReferralSummaryAPI((response) => {
      setLoading(false);
      if (!response || response.success === false) {
        setError(response?.error || 'Não foi possível carregar suas indicações. Tente de novo.');
        return;
      }
      setError(null);
      setSummary(response);
    });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleIndicated = (message, severity) => {
    setToast({ open: true, message, severity });
    if (severity === 'success') load();
  };

  return (
    <div className='page-content'>
      <div className={styles.page}>
        <header className={styles.header}>
          <h1 className={styles.title}>Indique e ganhe</h1>
          <p className={styles.subtitle}>
            Indique a Gabriela para um colega e ganhe um mês do seu plano quando ele assinar.
          </p>
        </header>

        {error && <Alert severity="error">{error}</Alert>}

        <div className={styles.grid}>
          <div className={styles.column}>
            <ReferralLinkCard code={summary?.code || null} loading={loading} />
            <ReferralIndicateCard dailyLimit={summary?.daily_limit || 20} onDone={handleIndicated} />
          </div>
          <div className={styles.column}>
            <ReferralListCard
              counts={summary?.counts || EMPTY_COUNTS}
              referrals={summary?.referrals || []}
              waitingCredits={summary?.waiting_credits || 0}
            />
          </div>
        </div>
      </div>

      <Toast
        open={toast.open}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        message={toast.message}
        severity={toast.severity}
      />
    </div>
  );
};

export default Referral;
